<template>
  <div>
    <el-card v-auth="'/discountCoupon/pageList'">
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="4">
          <el-input v-model="searchForm.keyword" placeholder="输入编号/优惠券名" auto-complete="off"></el-input>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6">
          <el-date-picker
            v-model="times"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            @change="timeChange"
            unlink-panels
            range-separator="至"
            start-placeholder="有效期开始日期"
            end-placeholder="有效期结束日期"
          ></el-date-picker>
        </el-col>

        <el-col :sm="24" :md="12" :lg="10" style="float:right">
          <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh"  style="text-align:right">重置</el-button> -->
          <div>
            <!-- <a @click="reset" class="mainColor ml">重置</a> -->
            <el-button-group style="float:right">
              <el-button type="primary" @click="pageList" v-auth="'/discountCoupon/pageList'" icon="el-icon-search">查询</el-button>
              <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
            </el-button-group>
          </div>

          <!-- <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
          <a @click="reset" class="mainColor ml">重置</a>-->
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card" style="margin-top: 10px;">
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="12" style="float:left;">
          <el-button-group style="float:left">
            <el-button type="primary" @click="updateVideoCourseState()" v-auth="'/discountCoupon/updateVideoCourseState'">批量下架</el-button>
            <el-button type="primary" @click="$router.push({path:'/addCoupon'})" v-auth="'/discountCoupon/addCoupon'">添加优惠券</el-button>
          </el-button-group>
        </el-col>
        <div
          class
          style="float:right;font-weight: bolder;line-height: 40px;color: #4e4e4e;margin-right:20px"
        >商品数量：{{page.total}}</div>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        @selection-change="selectionChange"
        border
      >
        <el-table-column type="selection" min-width="40"></el-table-column>
        <el-table-column show-overflow-tooltip width="160" prop="number" label="优惠券编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="有效期">
          <template slot-scope="scope">
            <span>{{scope.row.startTime}}-{{scope.row.endTime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="80"
          align="center"
          prop="discountPrice"
          label="优惠金额"
        >
          <template slot-scope="scope">
            <span>￥{{scope.row.discountPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="80"
          align="center"
          prop="limitPrice"
          label="使用门槛"
        >
          <template slot-scope="scope">
            <span>￥{{scope.row.limitPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="80" align="center" prop="type" label="商品范围"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="80"
          align="center"
          prop="remark"
          label="使用/发行"
        >
          <template slot-scope="scope">
            <span>{{scope.row.useQuantity}}/{{scope.row.quantity}}</span>
          </template>
        </el-table-column>

        <el-table-column width="80" align="center" show-overflow-tooltip prop="remark" label="状态">
          <!-- <template slot-scope="scope">
            <span>{{scope.row.state==1?"上架":'下架'}}</span>
          </template>-->
          <template slot-scope="row">
            <el-switch
              v-model="row.row.state"
              :active-value="1"
              :inactive-value="-1"
              @change="updateVideoCourseState2(row.row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="remark" label="有效期"></el-table-column> -->
        <el-table-column show-overflow-tooltip width="120" prop="remark" align="center" label="操作">
          <template slot-scope="scope">
            <i class="el-icon-edit icon-style" title="编辑" @click="goEdit(scope.row)" v-auth="'/discountCoupon/goEdit'"></i>
            <!-- <el-button type="text" size="small" @click="goEdit(scope.row)">编辑</el-button> -->
            <!-- <el-button
              type="text"
              size="small"
              @click="updateVideoCourseState2(scope.row)"
            >{{scope.row.state==1?'下架':'上架'}}</el-button>-->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      multipleSelection: [],
      searchForm: {
        keyword: "",
        endTime: "",
        startTime: ""
      },
      times: [],
      formLabelWidth: "80px",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1
      },
      loading: false
    };
  },
  created() {},
  methods: {
    updateVideoCourseState2(row) {
      console.log(row.state);
      let arr = [];
      arr.push({ id: row.id, state: row.state });
      this.api.discountCoupon
        .updateVideoCourseState(arr)
        .then(result => {
          if (result.success) {
            this.pageList();
            this.$message.success(result.message);
          } else {
            this.pageList();
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    goEdit(row) {
      this.$router.push({
        path: "/editCoupon",
        query: {
          id: row.id
        }
      });
    },

    updateVideoCourseState() {
      console.log(this.multipleSelection.length);
      if (this.multipleSelection.length > 0) {
        let arr = [];
        this.multipleSelection.forEach(res => {
          arr.push({ id: res.id, state: -1 });
        });
        this.api.discountCoupon
          .updateVideoCourseState(arr)
          .then(result => {
            if (result.success) {
              this.pageList();
              this.$message.success(result.message);
            } else {
              this.$message.error(result.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择要下架的优惠券！！！");
      }
    },

    selectionChange(val) {
      this.multipleSelection = val;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.discountCoupon
        .pageList(this.searchForm)
        .then(result => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    timeChange(val) {
      console.log(val);
      this.times = val;
      if (val.length == 2) {
        this.searchForm.startTime = val[0];
        this.searchForm.endTime = val[1];
      } else {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
      }
    },
    reset() {
      this.searchForm = {
        keyword: "",
        endTime: "",
        startTime: ""
      };
      this.times = [];
      this.pageList();
    }
  },
  watch: {},
  computed: {},
  mounted() {
    this.pageList();
  }
};
</script>

<style lang="less" rel="stylesheet/less">
</style>


// WEBPACK FOOTER //
// src/components/discountCoupon/index.vue